import React from 'react'
import { PayrollPaymentDashboard } from './PayrollPaymentDashboard'

export const PayrollPaymentList: React.FC = () => {
  return <PayrollPaymentDashboard showAddButton />
}
